
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

// bootstrap notification system
window.toastr = require('toastr');

// bootbox
window.bootbox = require('bootbox');

// google map location
window.googleMap = require('./google-map.js');

// application
window.$app = require('./main.js');

// bootstrap select
require('bootstrap-select');

// bootstrap datepicker
require("bootstrap-datepicker");

// bootstrap datepicker
require("bootstrap-fileinput");
